export default "__VITE_ASSET__BvWp1J3___"